module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'scrollbar/base' && templateVars.config ?
				templateVars.config :
				{
	"options": {
		"overflowBehavior": {
			"x": "hidden",
			"y": "scroll"
		}
	}
};